import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pt-14 pb-5 px-5" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex justify-start" }
const _hoisted_4 = { class: "relative h-42 w-288 me-3" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "px-5" }
const _hoisted_8 = { class: "flex justify-end" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { id: "excel-export" }, null, -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 1,
  class: "spinner"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Export", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_FilterPanel = _resolveComponent("FilterPanel")!
  const _component_vue_excel_xlsx = _resolveComponent("vue-excel-xlsx")!
  const _component_DynamicTable = _resolveComponent("DynamicTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PageTitle, { title: "reports.adminWallet" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SearchInput, {
            placeholder: _ctx.$t('placeholders.username'),
            modelValue: _ctx.searchValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
          }, null, 8, ["placeholder", "modelValue"])
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilterModal = true)),
          class: "border border-inputBorder w-42 h-42"
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_BaseIcon, { name: "filter" })
          ])
        ]),
        (_ctx.showFilterModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_FilterPanel, {
                filters: _ctx.filters,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterModal = false)),
                onFetchData: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onExpand($event)))
              }, null, 8, ["filters"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_vue_excel_xlsx, {
          data: _ctx.exportData,
          columns: _ctx.exportFields,
          "file-name": _ctx.reportType.name,
          "file-type": 'xlsx',
          "sheet-name": 'sheetname'
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createElementVNode("button", {
              disabled: _ctx.exportLoading,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportTableToExcel && _ctx.exportTableToExcel(...args))),
              class: "flex items-center primary px-4 py-2"
            }, [
              (!_ctx.exportLoading)
                ? (_openBlock(), _createBlock(_component_BaseIcon, {
                    key: 0,
                    name: "file-white"
                  }))
                : _createCommentVNode("", true),
              (_ctx.exportLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : _createCommentVNode("", true),
              _hoisted_12
            ], 8, _hoisted_10)
          ]),
          _: 1
        }, 8, ["data", "columns", "file-name"])
      ]),
      _createVNode(_component_DynamicTable, {
        tableData: _ctx.reports,
        loading: _ctx.loading,
        reportType: _ctx.reportType,
        pagination: _ctx.pagination,
        tableFields: _ctx.tableFields,
        stickyFooter: false,
        scrollable: true,
        collapseDataSourceField: "cashSettlementItems",
        collapsable: true,
        collapseFields: [
        { id: 'cashSettlementId', name: 'Cash Settlement ID', width: '15%'},
        { id: 'settlementNo', name: 'Settlement No (Smart ID)', width: '20%'},
        { id: 'date', name: 'Date'},
        { id: 'adminActionDate', name: 'Admin Action Date'},
        { id: 'amount', name: 'Amount'},
        { id: 'driverUsername', name: 'Driver'},
        { id: 'status', name: 'Status'},
        { id: 'erpNextSyncStatus', name: 'ERP Sync Status'},
      ],
        buttons: { edit: true, delete: true, export: true},
        onSort: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clickSort($event))),
        onMenuEvent: _cache[6] || (_cache[6] = ($event: any) => (_ctx.menuEvent($event)))
      }, null, 8, ["tableData", "loading", "reportType", "pagination", "tableFields", "collapseFields"])
    ])
  ], 64))
}